/**
 * Created by Josef Jurca on 5.6.2017.
 */

import { hashHistory } from 'react-router';

import { getInstance as getDataSources } from 'datasources';
import { getDevice } from 'utils/device/device';
import {
    setModalType,
    setStatus as setModalStatus,
    showModal,
    hideModal,
    setAfterClose,
    ModalTypes,
    ModalStatus
} from 'store/actions/modal';
import {getInstance as getStorageManager} from 'storage/manager';
import {
    setData as setDialogModalData
} from 'store/actions/modals/dialog';
import { Errors as DeviceErrors } from 'models/device';

// Action types
const ActionTypes = {
        SET_PLAYER: 'SET_PLAYER',
        MINIMIZE_PLAYER: 'MINIMIZE_PLAYER',
        SET_DEVICE_STATE: 'SET_DEVICE_STATE'
    },

    DeviceStates = {
        UNVERIFIED: 'UNVERIFIED',
        VERIFYING: 'VERIFYING',
        VERIFIED: 'VERIFIED',
        DEVICE_LIMIT_REACHED: 'DEVICE_LIMIT_REACHED',
        DEVICE_IN_ANOTHER_HOUSEHOLD: 'DEVICE_IN_ANOTHER_HOUSEHOLD'
    },
    storageManager = getStorageManager();

/**
 * Creates and returns a set player action.
 *
 * @param {Object} player - Player.
 * @returns {Object} Set asset action.
 */
function setPlayer (player) {

    return {
        type: ActionTypes.SET_PLAYER,
        player
    };
}

/**
 * Creates and returns a minimize player action.
 *
 * @param {boolean} minimize - If true, minimize player, if false, do not minimize.
 * @returns {Object} Set asset action.
 */
function minimizePlayer (minimize) {

    return {
        type: ActionTypes.MINIMIZE_PLAYER,
        minimize
    };
}

/**
 * Sets the devices state.
 *
 * @param {string} state - Device state.
 * @returns {Object} Action object.
 */
function setDeviceState (state) {

    return {
        type: ActionTypes.SET_DEVICE_STATE,
        state
    };
}

/**
 * Verifies the device by checking it against the api.
 *
 * @returns {Function} Async action.
 */
function verifyDevice () {

    return (dispatch) => {
        let dataSources = getDataSources();

        dispatch(setDeviceState(DeviceStates.VERIFYING));

        return getDevice()
            .then(dataSources.verifyDevice)
            .then(() => {

                dispatch(setDeviceState(DeviceStates.VERIFIED));
            })
            .catch((error) => {

                let onClose = () => {

                        dispatch(setPlayer({
                            on: false,
                            asset: {}
                        }));
                        dispatch(hideModal());
                        dispatch(setDeviceState(DeviceStates.UNVERIFIED));
                        
                        hashHistory.push('/settings');
						console.trace("hashHistory.push");

                    },
                    errorTitle = 'settings.errors.server-error.header',
                    errorDescription = 'settings.errors.server-error.description';

                switch (error) {
                    case DeviceErrors.DEVICE_LIMIT_REACHED:
                        dispatch(setDeviceState(DeviceStates.DEVICE_LIMIT_REACHED));
                        errorTitle = 'dialog.device-limit.title';
                        errorDescription = 'dialog.device-limit.text';
                        storageManager.store('player.deviceState', DeviceStates.DEVICE_LIMIT_REACHED);

                        break;

                    case DeviceErrors.DEVICE_IN_ANOTHER_HOUSEHOLD:
                        dispatch(setDeviceState(DeviceStates.DEVICE_IN_ANOTHER_HOUSEHOLD));
                        errorTitle = 'dialog.another-household.title';
                        errorDescription = 'dialog.another-household.text';
                        break;
                }

                dispatch(setAfterClose(onClose));
                dispatch(setModalStatus(ModalStatus.SHOW));
                dispatch(setDialogModalData({
                    title: errorTitle,
                    text: errorDescription,
                    buttons: [{
                        key: 'ok',
                        label: 'dialog.device-limit.buttons.ok',
                        action: onClose
                    }]
                }));
                dispatch(setModalType(ModalTypes.DIALOG));
                dispatch(showModal());
            });
    };
}

export {
    ActionTypes,
    DeviceStates,
    setPlayer,
    minimizePlayer,
    setDeviceState,
    verifyDevice
};


// WEBPACK FOOTER //
// ./src/js/store/actions/widgets/player.js